import React, { useContext, useEffect, useState } from "react";
import FsLightbox from "fslightbox-react";
import { Context } from "../../Store";
import CopiedContext from "../../CopiedContext";
import { trackEvent } from "../../utils/helpers";

const Lightbox = (props) => {
  const [state] = useContext(Context);
  const { setShowCopied } = React.useContext(CopiedContext);
  const { updateLightbox: registerLightboxSetter } = props;

  const [currentLightbox, setCurrentLightbox] = useState("");
  const [isActive, setIsActive] = useState(false);

  // props.updateLightbox(setCurrentLightbox)
  useEffect(() => {
    registerLightboxSetter(setCurrentLightbox);
  }, [registerLightboxSetter]);

  useEffect(() => {
    if (currentLightbox) {
      updateLightbox();
      if (
        currentLightbox.mediashare[currentLightbox.index].mediaType === "VIDEO"
      ) {
        trackEvent(
          "Expand Item",
          currentLightbox.section,
          currentLightbox.mediashare[currentLightbox.index].videoURL,
        );
      } else {
        trackEvent(
          "Expand Item",
          currentLightbox.section,
          currentLightbox.mediashare[currentLightbox.index].mediaURI,
        );
      }
    }
  }, [currentLightbox]);

  const updateLightbox = () => {
    setIsActive((prev) => !prev);
  };

  const copiedCallback = () => {
    setShowCopied(true);
  };

  const closeCallback = () => {
    setCurrentLightbox("");
    setIsActive(false);
  };

  return (
    <div>
      {currentLightbox !== "" && (
        <FsLightbox
          toggler={isActive}
          slide={currentLightbox.index + 1}
          sources={currentLightbox.sources}
          mediashare={currentLightbox.mediashare}
          type={currentLightbox.type}
          cityurl={state.cityurl}
          azureurl={state.azureurl}
          videourl={state.videourl}
          country={state.country}
          guid={state.guid}
          venue={state.venue}
          loadOnlyCurrentSource={true}
          onCopy={copiedCallback}
          onClose={closeCallback}
        />
      )}
    </div>
  );
};
export default Lightbox;
